import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import ModalComponent from "../../../../shared/Ui/ModalComponent/ModalWindow";
import style from "./OrderUpload.module.css";
import FileUpload from "../../../../shared/components/FileUpload/FileUpload";
import ModalButton from "../../../../shared/Ui/Buttons/ModalButtons";
import AlertBox from "../../../../shared/Ui/AlertBox/AlertBox";
import Loader from "../../../../shared/Ui/Loader/Loader";
import { importCodeMarks } from "../../../../common/api/ordersApi";

export interface IDocumentUpload {
  documentId: string | undefined;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  toggleOnLoad: boolean;
  setToggleOnLoad: Dispatch<SetStateAction<boolean>>;
  personalization?: any;
} 

export const DocumentUpload: React.FC<IDocumentUpload> = (props) => {
  const [alertOpen, setAlertOpen] = useState<any>(null);
  const { t, i18n } = useTranslation();
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [errorModal, setErrorModal] = useState<any>(null);

  const onModalOpen = () => props.setIsOpen(true);
  const onModalClose = () => {
    setUploadedFiles([])
  props.setIsOpen(false)
  };

  const [isResultsLoading, setIsResultsLoading] = useState<boolean>(false);

  async function onLoadResults() {
    if (!props.documentId) {
      console.error("OrderUpload: documentId отсутствует или некорректен", props.documentId);
      setErrorModal(t("documents_file_upload.error_file_format"));
      return;
    }
    if (uploadedFiles.length === 0) {
      console.warn("OrderUpload: файл не выбран");
      setErrorModal(t("components.no_file_selected"));
      return;
    }
    const file = uploadedFiles[0];
    const allowedExt = [".xlsx", ".xls", ".csv"];
    const allowedMime = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "text/csv",
    ];
    const hasValidExt = allowedExt.some((ext) => file.name?.toLowerCase().endsWith(ext));
    const hasValidMime = allowedMime.includes(file.type);
    if (!hasValidExt && !hasValidMime) {
      console.warn("OrderUpload: файл не соответствует формату", {
        name: file?.name,
        type: file?.type,
        allowedExt,
        allowedMime,
        hasValidExt,
        hasValidMime,
      });
      setErrorModal(t("documents_file_upload.error_file_format"));
      return;
    }
    setIsResultsLoading(true);
    try {
      await importCodeMarks(props.documentId, file);
      setAlertOpen({
        status: 'SUCCESS',
        message: t("documents_upload.successAddMarks"),
      });
      onModalClose();
    } catch (error:any) {
      setErrorModal(
        `${error?.response?.data?.message || t("documents_file_upload.error_file_format")}`,
      );
    } finally {
      setIsResultsLoading(false);
      props.setToggleOnLoad(!props.toggleOnLoad);
    }
  }

  const renderFileUpload = () => {
    return (
      <div className="flex flex-col">
        <div className="flex flex-row text-[20px] font-bold gap-[6px] text-gray-700 ">
          <span>{t("documents_file_upload.file_upload_title")}: </span>
        </div>
        <div className="text-gray-500 font-semibold text-base">
          <p>{t("documents_file_upload.file_upload_requirements")} </p>
          <ul className="flex flex-col gap-[6px] my-6">
            <li>{t("documents_file_upload.file_type_requirement")};</li>
            <li>{t("documents_file_upload.file_single_sheet")};</li>
            <li>{t("documents_file_upload.file_code_column")};</li>
            <li>{t("documents_file_upload.file_non_empty")};</li>
            <li>{t("documents_file_upload.file_text_cells")}.</li>
          </ul>
        </div>
        <div>
          <FileUpload
            setUploadedFiles={setUploadedFiles}
            uploadedFiles={uploadedFiles}
          />
        </div>
      </div>
    );
  };

  

  return (
    <>
    <AlertBox 
    isOpen={alertOpen} 
    setIsOpen={setAlertOpen} 
    />
      <ModalComponent
        classNameModal={style.modalWrapper}
        classNameContent="max-w-[1585px] w-full m-t-[20px]"
        content={renderFileUpload()}
        isOpen={props.isOpen}
        onClose={onModalClose}
        footerContent={
          <button
            className={`text-white font-bold py-2 px-4 rounded ${uploadedFiles?.length === 0 ? `bg-bg` : `bg-green hover:brightness-75`}`}
            type="button"
            onClick={() => onLoadResults()}
            disabled={uploadedFiles?.length === 0}
          >
            {t("mainButtons3.add")}
          </button>
        }
        cancelText={t("mainButtons.close")}
      />
      <ModalComponent
        isOpen={errorModal}
        onClose={() => setErrorModal(null)}
        headerContent={
          <h1 className="h__modal">
            {t("documents_file_upload.error_notification")}
          </h1>
        }
        content={
          <div className="error-list">
            {/* <h2>{t("documents_file_upload.errors_list")}:</h2> */}
            <p>{errorModal || t("documents_file_upload.error_file_format")}</p>
          </div>
        }
        customContent={
          <ModalButton
            type="button"
            onClick={() => {
              setErrorModal(null);
            }}
          >
            {t("mainButtons.accept")}
          </ModalButton>
        }
        
      />
      {isResultsLoading && <Loader />}
    </>
  );
};

export default DocumentUpload;
